import { KatapultElement, html } from '../../mixins/katapult-element';
import { KatapultEditorTemplate } from './katapult-editor-template';
import '@polymer/paper-toggle-button/paper-toggle-button.js';
import '../user-chooser/user-chooser.js';
import '../katapult-color-picker/katapult-color-picker-dialog.js';
import '../katapult-color-picker/katapult-color-picker-button.js';
import { Path } from '../../modules/Path.js';
import { ToArray } from '../../modules/ToArray.js';
import { NameToKey } from '../../modules/NameToKey.js';
import { BlackOrWhite } from '../../modules/BlackOrWhite.js';
import '../katapult-elements/katapult-button.js';
import '../katapult-elements/katapult-icon.js';
import '@shoelace-style/shoelace/dist/components/tooltip/tooltip.js';

class KatapultProjectEditor extends KatapultEditorTemplate {
  static get template() {
    return html`
      ${super.style}
      <style>
        user-chooser {
          --user-row-background: var(--paper-grey-50);
          background: var(--paper-grey-50);
          --user-row-border-color: transparent;
          --user-row: {
            text-decoration: underline;
            cursor: pointer;
          };
        }
        .label {
          border-radius: 10px;
          margin: 5px;
          padding-left: 10px;
          display: flex;
          align-items: center;
          border: 1px solid var(--paper-grey-300);
        }
        .userRow {
          height: auto;
          --paper-input-container: {
            padding: 0;
          };
        }
        .userRow paper-cell:not([icon-button]) {
          padding: 0 12px;
        }
        .dialog-option {
          min-width: 5.14em;
        }
        /*
        .itemDetails {
          padding: 12px;
          background-color: var(--paper-grey-50);
        }
        .itemDetails > div {
          box-sizing: border-box;
          width: 100%;
          display: flex;
        }
        .itemDetails > div > * {
          padding: 8px;
        }
        .itemDetailsHeader {
          font-size: 12pt;
          color: var(--paper-grey-600);
          text-transform: uppercase;
          padding: 8px;
        }
        .itemDetailsLabel {
          white-space: nowrap;
          font-weight: bold;
        } */
      </style>

      <katapult-firebase-worker id="projects" path="photoheight/company_space/[[userGroup]]/project_tracking/projects" data="{{projects}}">
      </katapult-firebase-worker>

      <katapult-firebase-worker id="labels" path="photoheight/company_space/[[userGroup]]/project_tracking/labels" data="{{labels}}">
      </katapult-firebase-worker>

      <katapult-firebase-worker id="users" path="photoheight/company_space/[[userGroup]]/users" data="{{users}}">
      </katapult-firebase-worker>

      <katapult-color-picker-dialog></katapult-color-picker-dialog>

      <paper-dialog
        id="editProjectLabels"
        entry-animation="scale-up-animation"
        exit-animation="fade-out-animation"
        no-cancel-on-outside-click=""
      >
        <div title secondary-color>Edit Project Labels</div>
        <paper-dialog-scrollable>
          <div body>
            <paper-table style="overflow: hidden;" white outline rounded dividers>
              <template is="dom-repeat" items="{{toArray(labels)}}">
                <paper-row item="[[item]]">
                  <paper-cell style="background-color:white;">
                    <div style="flex-grow:1; white-space: nowrap;">[[item.name]]</div>
                    <katapult-color-picker-button color="{{item.color}}" on-change="changeLabelColor"></katapult-color-picker-button>
                    <katapult-button iconOnly noBorder icon="delete" on-click="removeProjectLabel"></katapult-button>
                  </paper-cell>
                </paper-row>
              </template>
            </paper-table>
          </div>
        </paper-dialog-scrollable>
        <paper-row>
          <paper-cell>
            <paper-input
              id="newProjectLabelNameInput"
              label="New Project Label"
              value="{{newProjectLabelName}}"
              autofocus
              no-label-float
            ></paper-input>
          </paper-cell>
          <paper-cell icon-button>
            <katapult-button color="var(--secondary-color)" iconOnly noBorder icon="add" on-click="addNewProjectLabels"></katapult-button>
          </paper-cell>
        </paper-row>
        <div buttons>
          <katapult-button dialog-dismiss class="dialog-option">Close</katapult-button>
        </div>
      </paper-dialog>

      <paper-dialog id="editUserProjects">
        <div title secondary-color>
          Projects -<span style="text-transform:none; font-size: 12pt; margin-left: 5px;">[[userEmail(editUserProjects)]]</span>
        </div>
        <div body>
          <paper-table>
            <template is="dom-repeat" items="[[getUserProjects(editUserProjects, projects.*)]]">
              <paper-row>
                <paper-cell on-click="selectProject" style="text-decoration:underline; cursor:pointer;">[[item.name]]</paper-cell>
              </paper-row>
            </template>
          </paper-table>
        </div>
        <div buttons>
          <katapult-button dialog-dismiss class="dialog-option">Close</katapult-button>
        </div>
      </paper-dialog>

      <template is="dom-repeat" items="[[steps]]" as="step">
        <katapult-editor-step
          creating-item="[[creatingItem]]"
          active="[[step.active]]"
          index="[[step.index]]"
          current-index="[[currentIndex]]"
          title="[[step.title]]"
        >
          <template is="dom-if" if="[[equal(step.id, 'users')]]" restamp>
            <template is="dom-if" if="[[_itemData.users.length]]">
              <katapult-button style="margin-left: 16px;" slot="current-step-body" on-click="nextStep">Continue</katapult-button>
            </template>
            <paper-table light-grey rounded outline slot="body">
              <paper-row input style="height:auto;">
                <paper-cell>
                  <katapult-drop-down
                    id="userDropdown"
                    items="[[users]]"
                    label-path="email"
                    value-path="$key"
                    label="Who can put hours towards this project"
                    no-label-float
                    show-last-results
                    on-selected-changed="usersChanged"
                  >
                    <paper-item on-click="allUsers">All Users</paper-item>
                  </katapult-drop-down>
                </paper-cell>
              </paper-row>
              <template is="dom-repeat" items="{{_itemData.users}}" as="user">
                <paper-row class="userRow">
                  <paper-cell on-click="showUserList" style="min-width:300px; text-decoration:underline; cursor:pointer;">
                    <template is="dom-if" if="[[isOverhead(user.uid, users.*)]]">
                      <sl-tooltip hoist placement="bottom" content="This is an overhead user">
                        <katapult-icon
                          icon="account_circle"
                          color="var(--paper-red-500)"
                          style="margin-right: var(--sl-spacing-small);"
                        ></katapult-icon>
                      </sl-tooltip>
                    </template>
                    <span>[[user.email]]</span>
                  </paper-cell>
                  <paper-cell style="min-width:200px;">
                    <paper-textarea value="{{user.description}}" data-property="description" label="Description"></paper-textarea>
                  </paper-cell>
                  <paper-cell>
                    <paper-input type="date" value="{{user.start_date}}" data-property="start_date" label="Start Date"></paper-input>
                  </paper-cell>
                  <paper-cell>
                    <paper-input type="date" value="{{user.end_date}}" data-property="end_date" label="End Date"></paper-input>
                  </paper-cell>
                  <paper-cell>
                    <paper-checkbox checked="{{user.part_time_secondary}}">PTS</paper-checkbox>
                  </paper-cell>
                  <paper-cell icon-button>
                    <katapult-button icon="clear" iconOnly noBorder on-click="removeUser"></katapult-button>
                  </paper-cell>
                </paper-row>
              </template>
            </paper-table>
          </template>

          <template is="dom-if" if="[[equal(step.id, 'time_period')]]" restamp>
            <katapult-button style="margin-left: 16px;" slot="current-step-body" on-click="nextStep" class="dialog-option"
              >Skip</katapult-button
            >
            <paper-table light-grey style="width: 400px;" rounded outline slot="body">
              <paper-row input style="height:auto;">
                <paper-cell>
                  <paper-input type="date" value="{{_itemData.start_date}}" label="Start Date"></paper-input>
                  <paper-input type="date" value="{{_itemData.end_date}}" label="End Date" style="margin-left:10px"></paper-input>
                </paper-cell>
              </paper-row>
            </paper-table>
          </template>

          <template is="dom-if" if="[[equal(step.id, 'properties')]]" restamp>
            <katapult-button style="margin-left: 16px;" slot="current-step-body" on-click="nextStep" class="dialog-option"
              >Skip</katapult-button
            >
            <paper-table light-grey style="width: 400px;" rounded outline slot="body">
              <paper-row input style="height:auto;">
                <paper-cell>
                  <paper-checkbox checked="{{_itemData.overhead_category}}" style="margin-left:10px">Overhead Category</paper-checkbox>
                </paper-cell>
              </paper-row>
              <paper-row input style="height:auto;">
                <paper-cell>
                  <paper-checkbox checked="{{_itemData.archived}}" style="margin-left:10px">Archived</paper-checkbox>
                </paper-cell>
              </paper-row>
            </paper-table>
          </template>

          <template is="dom-if" if="[[equal(step.id, 'labels')]]" restamp>
            <template is="dom-if" if="[[!_itemData.labels.length]]">
              <katapult-button style="margin-left: 16px;" slot="current-step-body" on-click="nextStep" class="dialog-option"
                >Skip</katapult-button
              >
            </template>
            <template is="dom-if" if="[[_itemData.labels.length]]">
              <katapult-button style="margin-left: 16px;" slot="current-step-body" on-click="nextStep">Continue</katapult-button>
            </template>
            <paper-table light-grey style="width: 400px;" rounded outline slot="body">
              <paper-row input>
                <paper-cell>
                  <katapult-drop-down
                    items="[[labels]]"
                    label-path="name"
                    value-path="$key"
                    label="Add a Label"
                    on-selected-changed="addLabel"
                    no-label-float
                  >
                    <paper-item on-click="editProjectLabels">EDIT LABELS</paper-item>
                  </katapult-drop-down>
                </paper-cell>
              </paper-row>
              <paper-row style="flex-wrap: wrap; height: auto;">
                <template is="dom-repeat" items="[[getLabelDefinitions(_itemData.labels, labels, _itemData.labels.*, labels.*)]]">
                  <div class="label" style$="background-color:[[item.color]]; color:[[getTextColor(item.color)]];">
                    [[item.name]]<katapult-button
                      style="flex-shrink:0"
                      iconOnly
                      noBorder
                      icon="close"
                      on-click="removeLabel"
                    ></katapult-button>
                  </div>
                </template>
              </paper-row>
            </paper-table>
          </template>

          <template is="dom-if" if="[[equal(step.id, 'type')]]" restamp>
            <paper-table light-grey style="width: 400px;" rounded outline slot="body">
              <paper-row input style="height:auto;">
                <paper-cell>
                  <katapult-drop-down
                    items="[[projectTypes]]"
                    label="What type of tracking"
                    value="{{_itemData.type}}"
                    no-label-float
                    value-path="$key"
                    label-path="$val"
                  ></katapult-drop-down>
                </paper-cell>
              </paper-row>
            </paper-table>
          </template>

          <template is="dom-if" if="[[equal(step.id, 'invoiceable_amount')]]" restamp>
            <katapult-button style="margin-left: 16px;" slot="current-step-body" on-click="nextStep" class="dialog-option"
              >Skip</katapult-button
            >
            <paper-table light-grey style="width: 400px;" rounded outline slot="body">
              <paper-row input style="height:auto;">
                <paper-cell>
                  <paper-input type="number" value="{{_itemData.invoiceable_amount}}" label="Invoiceable Amount" no-label-float>
                    <div slot="prefix" style="margin-right:5px">$</div>
                  </paper-input>
                </paper-cell>
              </paper-row>
            </paper-table>
          </template>

          <template is="dom-if" if="[[equal(step.id, 'units')]]" restamp>
            <katapult-button style="margin-left: 16px;" slot="current-step-body" on-click="nextStep">Continue</katapult-button>
            <paper-table light-grey style="width: 600px;" rounded outline slot="body">
              <template is="dom-repeat" items="{{_itemData.units}}">
                <paper-row>
                  <paper-cell>
                    <paper-input label="Name" value="{{item.name}}"></paper-input>
                  </paper-cell>
                  <template is="dom-if" if="[[equal(_itemData.type, 'recurring')]]">
                    <paper-cell>
                      <katapult-drop-down
                        items="[[recurringFrequencies]]"
                        label="Frequency"
                        value="{{item.frequency}}"
                      ></katapult-drop-down>
                    </paper-cell>
                  </template>
                  <paper-cell>
                    <paper-input label="Price (optional)" type="number" value="{{item.price}}">
                      <div slot="prefix" style="margin-right:5px">$</div>
                    </paper-input>
                  </paper-cell>
                  <!-- <paper-cell>
                    <paper-input label="Quantity" type="number" value="{{item.quantity}}"></paper-input>
                  </paper-cell> -->
                </paper-row>
              </template>
              <paper-row grey divider style="margin-top:10px;">
                <paper-cell style="min-width: fit-content; color: var(--paper-grey-600);" on-click="addUnit" pointer ripple center>
                  <span>ADD UNIT</span>
                  <iron-icon style="margin-left: 8px;" icon="av:playlist-add"></iron-icon>
                </paper-cell>
              </paper-row>
            </paper-table>
          </template>

          <!-- <template is="dom-if" if="[[equal(step.id, 'invoice_items')]]" restamp>
            <katapult-button style="margin-left: 16px;" slot="current-step-body" on-click="nextStep">Continue</katapult-button>
            
            <paper-table white style="width: 600px; position: relative;" rounded outline overflow-hidden dividers slot="body">
              <template is="dom-repeat" items="[[getItemsArray(_itemData.invoice_items.*)]]" mutable-data>
                <paper-header-content white expand no-click-row>
                  <paper-cell slot="header" icon>
                    <material-icon icon="sell"></material-icon>
                  </paper-cell>
                  <paper-cell slot="header">
                    <paper-input label="Item Name" no-label-float value="[[item.name]]"
                      data-path="_itemData.invoice_items.$(model.item.$key).name" on-value-changed="updateProperty"
                    ></paper-input>
                    <div style="margin-left: 16px;" hidden$="[[_isFalsy(item.default_price)]]">( $[[item.default_price]] )</div>
                    <div style="margin-left: 16px;" hidden$="[[!_isFalsy(item.default_price)]]">( no set price )</div>
                  </paper-cell>

                  <div slot="content" flex column align-start class="itemDetails">
                    <div flex align-center>
                      <material-icon icon="description"></material-icon>
                      <div class="itemDetailsLabel">Description</div>
                      <paper-input placeholder="Brief explanation of what this line item represents" no-label-float value="[[item.description]]"
                        data-path="_itemData.invoice_items.$(model.item.$key).description" on-value-changed="updateProperty"
                      ></paper-input>
                    </div>
                    <div flex align-center>
                      <material-icon icon="paid"></material-icon>
                      <div class="itemDetailsLabel">Default Price</div>
                      <paper-input placeholder="(ex. 100)" type="number" no-label-float value="[[item.default_price]]"
                        data-path="_itemData.invoice_items.$(model.item.$key).default_price" on-value-changed="updateProperty"
                      >
                        <div slot="prefix" style="margin-right: 4px;">$</div>
                      </paper-input>
                    </div>
                    <div flex align-center>
                      <material-icon icon="tune"></material-icon>
                      <div class="itemDetailsLabel">Prompt to Adjust</div>
                      <paper-radio-group selected="[[item.adjustment_prompt]]"
                        data-path="_itemData.invoice_items.$(model.item.$key).adjustment_prompt" on-selected-changed="updateProperty"
                      >
                        <paper-radio-button name="NONE">Never</paper-radio-button>
                        <paper-radio-button name="DOLLAR">By Dollars</paper-radio-button>
                        <paper-radio-button name="PERCENT">By Percentage</paper-radio-button>
                      </paper-radio-group>
                    </div>
                    <div flex align-center>
                      <material-icon icon="123"></material-icon>
                      <div class="itemDetailsLabel">Default Quantity</div>
                      <paper-input placeholder="(ex. 25)" type="number" no-label-float value="[[item.default_quantity]]"
                        data-path="_itemData.invoice_items.$(model.item.$key).default_quantity" on-value-changed="updateProperty"
                      ></paper-input>
                    </div>

                    <div class="itemDetailsHeader">Schedule</div>
                    <div flex align-center>
                      <material-icon icon="schedule"></material-icon>
                      <div class="itemDetailsLabel">Billing Schedule</div>
                      <paper-radio-group selected="[[item.schedule]]"
                        data-path="_itemData.invoice_items.$(model.item.$key).schedule" on-selected-changed="updateProperty"
                      >
                        <paper-radio-button name="RECURRING">Recurring</paper-radio-button>
                        <paper-radio-button name="OCCASIONALLY">Occasionally</paper-radio-button>
                        <paper-radio-button name="ONCE">Only Once</paper-radio-button>
                      </paper-radio-group>
                    </div>
                    <div flex align-center>
                      <material-icon icon="today"></material-icon>
                      <div class="itemDetailsLabel">Starts On</div>
                      <paper-input type="date" value="[[item.start_on]]" no-label-float
                        data-path="_itemData.invoice_items.$(model.item.$key).start_on" on-value-changed="updateProperty"
                      ></paper-input>
                    </div>
                    <div flex align-center>
                      <material-icon icon="event_repeat"></material-icon>
                      <div class="itemDetailsLabel">Repeats</div>
                      <katapult-drop-down label="Frequency" no-label-float items="[[recurringFrequencies]]" selected="[[item.repeat_frequency]]"
                        data-path="_itemData.invoice_items.$(model.item.$key).repeat_frequency" on-selected-changed="updateProperty"
                      ></katapult-drop-down>
                    </div>

                    <div class="itemDetailsHeader">Automation</div>
                    <div flex align-center>
                      <material-icon icon="auto_mode"></material-icon>
                      <div class="itemDetailsLabel">Auto-Generate</div>
                      <paper-toggle-button checked="[[item.auto_generate]]"
                      data-path="_itemData.invoice_items.$(model.item.$key).auto_generate" on-checked-changed="updateProperty"
                      >Auto-generate entries for this item on the above schedule</paper-toggle-button>
                    </div>
                    <div flex align-center>
                      <material-icon icon="functions"></material-icon>
                      <div class="itemDetailsLabel">Quantity Expression</div>
                      <k-logic-editor block="[[item.quantity_expression]]"
                        data-path="_itemData.invoice_items.$(model.item.$key).quantity_expression" on-expression-changed="updateProperty"
                      ></k-logic-editor>
                    </div>
                  </div>
                </paper-header-content>
              </template>
              <paper-row grey divider>
                <paper-cell style="min-width: fit-content; color: var(--paper-grey-600);" data-list="invoice_items" on-click="addListItem" pointer ripple center>
                  <span>ADD LINE ITEM</span>
                  <iron-icon style="margin-left: 8px;" icon="av:playlist-add"></iron-icon>
                </paper-cell>
              </paper-row>
            </paper-table>
          </template> -->
        </katapult-editor-step>
      </template>
      ${super.createItemContainer}
    `;
  }

  static get properties() {
    return {
      projectTypes: {
        type: Object,
        value: () => ({
          none: 'None',
          lump_sum: 'Lump Sum',
          recurring: 'Recurring',
          job_tracking: 'Job Tracking (Coming Soon)',
          cogs: 'Cost of Goods Sold (Coming Soon)'
        })
      },
      recurringFrequencies: {
        type: Array,
        readOnly: true,
        value: () => ['Yearly', 'Monthly', 'Weekly', 'Daily']
        // value: () => [ 'YEARLY', 'MONTHLY', 'WEEKLY', 'DAILY', 'ONCE', 'OCCASIONALLY' ]
      }
    };
  }

  static get observers() {
    return [];
  }

  constructor() {
    super();

    this._fallback = (...values) => values.find((x) => x);
    this._isFalsy = (value) => !value == true;
  }

  ready() {
    super.ready();
    this.labelAllowAllCharacters = true;
    this.keyMatchLabel = true;
    this.lastModifiedPath = '_last_modified';

    // An ordered list of all possible steps.
    this.setSteps([
      {
        id: 'users',
        title: 'Users',
        trigger: () => this._itemData?.users?.some((x) => x.uid == '_all')
      },
      // {
      //   id:'time_period',
      //   title:'Time Period',
      //   trigger:() => (this.get('_itemData.start_date') && this.get('_itemData.end_date'))
      // },
      {
        id: 'properties',
        title: 'Properties',
        trigger: () => this.get('_itemData.overhead_category')
      },
      {
        id: 'labels',
        title: 'Labels',
        trigger: () => this.get('_itemData.labels.length')
      },
      {
        id: 'type',
        title: 'Type of Tracking',
        trigger: () => this.get('_itemData.type')
      },
      {
        id: 'units',
        title: 'Invoiceable Units',
        if: () => ['lump_sum', 'recurring'].includes(this.get('_itemData.type')),
        trigger: () => this.get('_itemData.units') !== undefined
      }
      // {
      //   id:'invoice_items',
      //   title:'Invoice Line Items',
      //   trigger: () => this.get('_itemData.invoice_items') !== undefined
      // },
    ]);
  }

  toArray(a) {
    return ToArray(a);
  }

  equal(a, b) {
    return a == b;
  }

  addUnit() {
    if (!this.get('_itemData.units')) {
      this.set('_itemData.units', []);
    }
    let unit = { name: '', price: '' };
    if (this.get('_itemData.type') == 'recurring') {
      unit.freqency = '';
    }
    this.push('_itemData.units', unit);
  }

  // addListItem(e) {
  //   const list = e.currentTarget.dataset.list;
  //   // const path = `_itemData.${list}`;
  //   // if (!this.get(path)) this.set(path, {});
  //   const key = FirebaseWorker.ref().push().key;
  //   this.deepSet(`_itemData.${list}.${key}`, {});

  //   // this.push(path, {});
  // }

  labelChanged(label) {
    this.set('_itemData.name', label);
  }

  allUsers() {
    this.shadowRoot.querySelector('#userDropdown').close();
    this.set('_itemData.users', [{ uid: '_all', email: 'All Users' }]);
  }

  getItemUsersArray(users) {
    return ToArray(Path.copy(users || []))
      .filter((x) => x.$val !== null)
      .map((user) => {
        user.uid = user.$key;
        delete user.$key;
        return user;
      });
  }

  isOverhead(uid) {
    return this.get(`users.${uid}.employment.overhead_employee`);
  }

  usersChanged(e) {
    if (!this.get('_itemData.users')) {
      this.set('_itemData.users', []);
    }
    const userKey = e.detail.value;
    const user = this.users?.[userKey];
    if (!user) return;
    const { uid, email } = user;
    this.push('_itemData.users', { uid, email });
    e.currentTarget.clear();
  }

  removeUser(e) {
    this.splice('_itemData.users', e.model.index, 1);
  }

  editProjectLabels(e) {
    e.currentTarget.parentElement.close();
    this.$.editProjectLabels.open();
  }

  addNewProjectLabels(e) {
    this.$.labels._ref.child(NameToKey(this.newProjectLabelName)).set({
      name: this.newProjectLabelName,
      color: 'black'
    });
  }

  removeProjectLabel(e) {
    let label = e.model.item.$key;
    let update = {};
    update['labels/' + label] = null;
    for (let projectId in this.projects) {
      let labels = this.projects[projectId].labels || [];
      if (labels.includes(label)) {
        update['projects/' + projectId + '/labels'] = labels.splice(labels.indexOf(label), 1);
      }
    }
    FirebaseWorker.ref(`photoheight/company_space/${this.userGroup}/project_tracking`).update(update);
  }

  changeLabelColor(e) {
    this.$.labels._ref.child(e.model.item.$key + '/color').set(e.detail.color);
  }

  addLabel(e) {
    if (e.detail.value) {
      this._itemData.labels = this._itemData.labels || [];
      this.push('_itemData.labels', e.detail.value);
      e.currentTarget.clear();
    }
  }

  removeLabel(e) {
    this.splice('_itemData.labels', e.model.index, 1);
  }

  getLabelDefinitions(cat, labels) {
    return (cat || []).map((x) => labels[x]);
  }

  getTextColor(color) {
    return BlackOrWhite(color, true);
  }

  showUserList(e) {
    this.editUserProjects = e.model.user.uid;
    this.$.editUserProjects.open();
  }

  userEmail(uid) {
    return this.get(`users.${uid}.email`);
  }

  getUserProjects(uid) {
    let projects = [];
    for (let id in this.projects) {
      if (this.projects[id].users?.some((x) => x.uid == '_all' || x.uid == uid)) {
        let project = Path.copy(this.projects[id]);
        project.$key = id;
        projects.push(project);
      }
    }
    return projects;
  }

  selectProject(e) {
    this.$.editUserProjects.close();
    this.dispatchEvent(new CustomEvent('item-set', { detail: { itemKey: e.model.item.$key } }));
  }

  updateUserAttribute(e) {
    this.set(`_itemData.users.${e.model.user.uid}.${e.currentTarget.dataset.property}`, e.detail.value);
  }

  // TODO (05-25-2022): Remove this, it will eventually be available through katapult-editor-template
  // getItemsArray(...args) {
  //   // Convert change event objects to their base values.
  //   args = args.map(x => ['base', 'path', 'value'].every(p => x?.hasOwnProperty(p)) ? x.base : x);
  //   // Pass into toArray().
  //   let res = k.toArray(...args);
  //   // Filter out null values.
  //   res = res.filter(x => x != null && (!x.hasOwnProperty('$val') || x.$val != null));
  //   // Return result.
  //   return res;
  // }
}

customElements.define('katapult-project-editor', KatapultProjectEditor);
